/**
 * Custom Image Slider Component
 * Used for sections like "Inspiration for every room" and "Fitment Craft Family"
 */

if (!customElements.get('image-slider')) {
    class ImageSlider extends HTMLElement {
        constructor() {
            super();
            this.track = this.querySelector('.slider-track');
            this.prevBtn = this.querySelector('.prev-btn');
            this.nextBtn = this.querySelector('.next-btn');

            if (!this.track || !this.prevBtn || !this.nextBtn) return;

            this.init();
        }

        init() {
            // Set initial button states
            setTimeout(() => this.updateButtons(), 100);

            const prev = this.prevBtn;
            const next = this.nextBtn;
            const track = this.track;

            if (prev) prev.addEventListener('click', () => this.scroll('left'));
            if (next) next.addEventListener('click', () => this.scroll('right'));

            if (track instanceof HTMLElement) {
                track.addEventListener('scroll', () => this.updateButtons(), { passive: true });

                // Drag support
                let isDown = false;
                let startX = 0;
                let scrollLeft = 0;

                track.addEventListener('mousedown', (e) => {
                    if (!(e instanceof MouseEvent)) return;
                    isDown = true;
                    track.classList.add('active');
                    track.style.cursor = 'grabbing';
                    startX = e.pageX - track.offsetLeft;
                    scrollLeft = track.scrollLeft;
                });

                track.addEventListener('mouseleave', () => {
                    isDown = false;
                    track.style.cursor = 'grab';
                });

                track.addEventListener('mouseup', () => {
                    isDown = false;
                    track.style.cursor = 'grab';
                });

                track.addEventListener('mousemove', (e) => {
                    if (!isDown || !(e instanceof MouseEvent)) return;
                    e.preventDefault();
                    const x = e.pageX - track.offsetLeft;
                    const walk = (x - startX) * 2;
                    track.scrollLeft = scrollLeft - walk;
                });
            }

            window.addEventListener('resize', () => this.updateButtons(), { passive: true });
        }

        getStepSize() {
            if (!(this.track instanceof HTMLElement)) return 0;
            const slide = this.track.querySelector('.slider-slide');
            if (!(slide instanceof HTMLElement)) return 0;
            const style = window.getComputedStyle(this.track);
            const gap = parseInt(style.gap) || 0;
            return slide.offsetWidth + gap;
        }

        scroll(direction) {
            if (!(this.track instanceof HTMLElement)) return;
            const step = this.getStepSize();
            const amount = direction === 'left' ? -step : step;
            this.track.scrollBy({ left: amount, behavior: 'smooth' });
        }

        updateButtons() {
            if (!(this.track instanceof HTMLElement) || !this.prevBtn || !this.nextBtn) return;
            const tolerance = 5;
            const atStart = this.track.scrollLeft <= tolerance;
            const atEnd = this.track.scrollLeft + this.track.offsetWidth >= this.track.scrollWidth - tolerance;

            if (this.prevBtn instanceof HTMLButtonElement) this.prevBtn.disabled = atStart;
            if (this.nextBtn instanceof HTMLButtonElement) this.nextBtn.disabled = atEnd;
        }
    }

    customElements.define('image-slider', ImageSlider);
}
